<template>
	<div
		class="event-calendar-item"
		:class="{ isComingSoon: data.isComingSoonItem && data.comingSoonData.shopStatus }"
		v-if="data"
	>
		<!-- IF Shop theme has shoptileimage: -->

		<img
			class="event-calendar-item__hero"
			v-if="
				data.shopTheme &&
				data.shopTheme.fields &&
				data.shopTheme.fields.shopOverviewImage &&
				data.shopTheme.fields.shopOverviewImage.fields &&
				data.shopTheme.fields.shopOverviewImage.fields.file
			"
			:src="data.shopTheme.fields.shopOverviewImage.fields.file.url"
			:alt="data.shopTheme.fields.shopOverviewImage.fields.title"
		/>

		<!-- Else use background image from shop theme -->

		<img class="event-calendar-item__hero" v-else :src="data.heroImage" alt="" />

		<div class="event-calendar-item__content">
			<h3 class="event-calendar-item__heading">{{ data.titleFull }}</h3>

			<ul class="event-calendar-item__body">
				<li class="event-calendar-item__list-item">
					<Location />

					<span class="event-calendar-item__detail">{{ data.location }}</span>
				</li>

				<li class="event-calendar-item__list-item" v-if="data.dateStart">
					<Calendar />

					<span class="event-calendar-item__detail">
						<!-- Show event start date  -->
						{{ data.dateStart | eventDateTime(data.eventDateTimeFormat) }}
						<!-- Show event end date  -->

						<span v-if="data.showEventEndsOn && data.dateEnd"
							>- {{ data.dateEnd | eventDateTime(data.eventDateTimeFormat) }}</span
						>
					</span>
				</li>

				<!-- Coming soon item date -->

				<li class="event-calendar-item__list-item" v-else-if="data.isComingSoonItem && data.comingSoonData">
					<Calendar />

					<span class="event-calendar-item__detail">{{ data.comingSoonData.dateText }}</span>
				</li>

				<div class="event-calendar-item__list-item" v-if="data.isComingSoonItem && data.comingSoonData">
					<IconAlert />

					<span class="event-calendar-item__detail"> {{ data.comingSoonData.shopStatus }} </span>
				</div>
			</ul>
		</div>

		<div class="event-calendar-item__content--bottom">
			<template v-if="!data.isComingSoonItem">
				<a
					v-if="data.queueUrl && !isTest"
					class="event-calendar-item__button"
					:href="preserveUTMParams(data.queueUrl)"
				>
					<span class="event-calendar-item__label">{{ getButtonLabel }}</span>
				</a>

				<a
					v-else-if="data.url"
					class="event-calendar-item__button"
					:href="preserveUTMParams(data.url)"
					target="_blank"
				>
					<span class="event-calendar-item__label">{{ getButtonLabel }}</span>
				</a>

				<nuxt-link
					v-else
					class="event-calendar-item__button"
					:to="{ path: `/${data.slug}`, query: $route.query }"
				>
					<span class="event-calendar-item__label">{{ getButtonLabel }}</span>
				</nuxt-link>
			</template>

			<template v-else-if="data.isComingSoonItem && data.comingSoonData">
				<a
					v-if="data.url && data.comingSoonData.buttonLabel"
					class="event-calendar-item__button"
					:href="data.url"
					target="_blank"
				>
					<span class="event-calendar-item__label">{{ data.comingSoonData.buttonLabel }}</span>
				</a>

				<div
					class="event-calendar-item__button event-calendar-item__button--no-uri"
					v-else-if="data.comingSoonData.buttonLabel"
				>
					<span class="event-calendar-item__label">{{ data.comingSoonData.buttonLabel }}</span>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import preserveUTMParams from '@/utils/preserveUTMParams';
export default {
	name: 'EventCalendarItem',

	props: {
		data: {
			date: String,
			heroImage: String,
			slug: String,
			title: String,
			titleFull: String,
			location: String,
			membersale: Boolean,
			travelsale: Boolean,
			preregistration: Boolean,
			queueUrl: String,
			comingSoonData: Object,
			showEventEndsOn: Boolean,
			shopTheme: Object
		}
	},

	computed: {
		isTest() {
			return process.env.ENV === 'dev';
		},

		getButtonLabel() {
			if (this.data.membersale) return this.$t('label.shop.member_sale');
			if (this.data.travelsale) return this.$t('label.shop.travel_sale');
			if (this.data.preregistration) return this.$t('label.shop.preregistration_sale');
			if (this.data.wishlist) return this.$t('label.shop.wishlist');

			return this.$t('label.shop.regular_sale');
		},

		locale() {
			return this.$store.getters.getLocale;
		}
	},
	methods: {
		preserveUTMParams
	}
	// Document isn't defined earlier than here	}
};
</script>

<style lang="scss">
$component: 'event-calendar-item';

$height: 293px;
$comingSoonHeight: 313px;

.#{$component} {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: $height;
	padding: $global-spacing;
	color: $color-white;
	background-image: linear-gradient(270deg, rgba(21, 21, 33, 0) 0%, #161622 71%);
	box-shadow: 0 2px 23px 0 rgba(0, 0, 0, 0.5);

	&.isComingSoon {
		height: $comingSoonHeight;
	}

	&__heading {
		text-transform: uppercase;
	}

	&__content {
		flex: 2;

		&--bottom {
			margin-top: auto;
		}
	}

	&__body {
		padding-top: 20px;
	}

	&__button {
		display: inline-block;
		position: relative;

		display: flex;

		// width: 190px;
		max-width: 220px;
		height: 50px;

		background-color: lighten($color-dark-blue, 10%);
		box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.5);

		text-decoration: none;

		&:after {
			content: '';
			position: absolute;

			top: 0;
			right: -10px;

			border-top: 25px solid transparent;
			border-bottom: 25px solid transparent;
			border-left: 10px solid lighten($color-dark-blue, 10%);
		}

		html.no-touchevents & {
			transition: background-color 0.3s $ease-out-cubic;

			&:after {
				transition: border-color 0.3s $ease-out-cubic;
			}

			&:hover {
				background-color: lighten($color-dark-blue, 30%);

				&:after {
					border-left-color: lighten($color-dark-blue, 30%);
				}
			}

			&--no-uri {
				cursor: initial;
				&:hover {
					background-color: lighten($color-dark-blue, 10%);
					&:after {
						border-left-color: lighten($color-dark-blue, 10%);
					}
				}
			}
		}
	}

	&__label {
		display: block;

		text-shadow: 0 1px 0 #000000;
		text-transform: uppercase;
		font-family: $font-bold;
		font-size: 18px;
		line-height: 50px;

		padding-left: 15px;
	}

	&__list-item {
		display: flex;
		align-items: center;

		> svg {
			margin-right: 10px;
		}

		&:not(:first-child) {
			padding-top: 8px;
		}
	}

	&__detail {
		display: block;
		font-size: 12px;

		color: $color-grey;
	}

	&__hero {
		position: absolute;

		z-index: -1;

		width: 100%;
		height: 100%;

		top: 0;
		left: 0;

		@include object-fit(cover, center);
	}

	&__shop-status-lable {
		position: relative;
		background: rgba($color: #ffffff, $alpha: 0.75);
		align-self: flex-start;
		font-family: $font-bold;
		color: $color-black;
		text-transform: uppercase;
		font-size: 10px;
		padding: 8px 8px 8px;
		height: 34px;
		max-width: 95%;

		letter-spacing: 1px;

		margin-bottom: 15px;
		margin-left: 10px;

		span {
			display: block;
			overflow: hidden;
			width: 100%;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		&:before {
			content: '';
			position: absolute;

			top: 0;
			right: -10px;

			border-top: 17px solid transparent;
			border-bottom: 17px solid transparent;
			border-left: 10px solid rgba($color: #ffffff, $alpha: 0.75);
		}

		&:after {
			content: '';
			position: absolute;

			top: 0;
			left: -10px;

			border-top: 17px solid transparent;
			border-bottom: 17px solid transparent;
			border-right: 10px solid rgba($color: #ffffff, $alpha: 0.75);
		}
	}

	@include sm {
		height: $height - 52;

		&.isComingSoon {
			height: $comingSoonHeight - 32;
		}

		&__button {
			height: 40px;

			&:after {
				border-top: 20px solid transparent;
				border-bottom: 20px solid transparent;
			}
		}

		&__label {
			line-height: 40px;
		}

		&__content {
			flex: auto;

			height: 100px;
		}
	}
}
</style>
